import React, { forwardRef, useCallback, useEffect, useState } from 'react';

import { Input } from 'antd';
import Wrapper from './IndigoPhoneInput.styled';

export interface PhoneValue {
  code?: string;
  number?: string;
}

export interface FunctionComponentProps {
  phoneCodePlaceholder?: string;
  phoneNumberPlaceholder?: string;
  value?: PhoneValue;
  disabled?: boolean;
  onChange?: (value: PhoneValue) => void;
  suffix?: React.ReactNode;
}

export const IndigoPhoneInput = forwardRef<unknown, FunctionComponentProps>(
  (
    {
      phoneCodePlaceholder,
      phoneNumberPlaceholder,
      onChange,
      value = {},
      disabled,
      suffix,
    },
    ref,
  ) => {
    const [code, setCode] = useState('+65');
    const [number, setNumber] = useState('');

    // const triggerChange = (changedValue: PhoneValue) => {
    //   if (onChange) {
    //     onChange({ code, number, ...value, ...changedValue });
    //   }
    // };

    const triggerChange = (changedValue: PhoneValue) => {
      if (onChange) {
        onChange({ code, number, ...value, ...changedValue });
      }
    };

    const handleOnChangePhoneCode = (code: string) => {
      setCode(code);
      // value.code = code;
      triggerChange({ code: code });
    };

    const handleOnChangePhoneNumber = (number: string) => {
      setNumber(number);
      if (typeof value.code === 'undefined' || value.code === '') {
        console.log('this should work');
        handleOnChangePhoneCode('+65');
      }
      // value.number = number;
      triggerChange({ number: number });
    };
    // eslint-disable-next-line
    const initValue = useCallback(() => {
      console.log('initValue');
      if (!value.code && !value.number) {
        triggerChange({
          code: code,
          number: number,
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      // initValue();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <Wrapper>
        <Input
          style={{
            width: 50,
            borderRadius: 4,
            background: '#fff',
            position: 'absolute',
            top: 6,
            left: 8,
            zIndex: 9,
            padding: 6,
          }}
          value={value.code || code}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleOnChangePhoneCode(e.target.value)
          }
          disabled={disabled}
          placeholder={phoneCodePlaceholder || '+00'}
        />
        <Input
          style={{
            paddingLeft: 64,
          }}
          value={value.number || number}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleOnChangePhoneNumber(e.target.value)
          }
          disabled={disabled}
          placeholder={phoneNumberPlaceholder || 'Fill in mobile number'}
          suffix={suffix ? suffix : null}
        />
      </Wrapper>
    );
  },
);
